import { createSlice } from "@reduxjs/toolkit";

/**
 * Per-route table preferences that must survive navigating into an invoice and
 * back: sort column, page and page size, and which row was last opened so it can be
 * highlighted on return.
 *
 * Replaces the old app's `sortingSlice` plus `saveClickedRowIndexSlice`, which
 * hardcoded one field per list page (`invoicesRowIndex`, `myInvoicesRowIndex`,
 * `inQueryInvoicesRowIndex`, `failedInvoicesRowIndex`) and so needed a code
 * change for every new queue. Keyed by route instead.
 */

const DEFAULT_PREFS = {
  sortBy: null,
  sortDirection: null,
  pageSize: 16,
  pageNumber: 1,
  lastOpenedId: null,
};

const tablePrefsSlice = createSlice({
  name: "tablePrefs",
  initialState: {},
  reducers: {
    setSorting: (state, action) => {
      const { key, sortBy, sortDirection } = action.payload;
      state[key] = { ...DEFAULT_PREFS, ...state[key], sortBy, sortDirection };
    },
    clearSorting: (state, action) => {
      const key = action.payload;
      state[key] = { ...DEFAULT_PREFS, ...state[key], sortBy: null, sortDirection: null };
    },
    setPageSize: (state, action) => {
      const { key, pageSize } = action.payload;
      state[key] = { ...DEFAULT_PREFS, ...state[key], pageSize };
    },
    setPageNumber: (state, action) => {
      const { key, pageNumber } = action.payload;
      state[key] = { ...DEFAULT_PREFS, ...state[key], pageNumber };
    },
    setLastOpenedId: (state, action) => {
      const { key, id } = action.payload;
      state[key] = { ...DEFAULT_PREFS, ...state[key], lastOpenedId: id };
    },
  },
});

export const { setSorting, clearSorting, setPageSize, setPageNumber, setLastOpenedId } = tablePrefsSlice.actions;

export default tablePrefsSlice.reducer;

export const selectTablePrefs = (key) => (state) => state.tablePrefs[key] ?? DEFAULT_PREFS;
